import React from "react";
import { motion } from "framer-motion";
import Admission from "./Admission";
import AdmissionHero from "./AdmissionHero";

const AdmissionDetails = () => {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex flex-col"
    >
      {/* <Header /> */}
      <AdmissionHero />
      <Admission />
    </motion.div>
  );
};

export default AdmissionDetails;